var App = App || {};

App = (() => {
    "use strict";
    // Initialize the application
    const init = () => {
        // Handle chat link & smooth scrolling for anchor links
        document.querySelectorAll('a[href^="#"]:not(.skipto, #sbModalSubmit, [data-copy], [data-bs-toggle])')
            .forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    const href = link.getAttribute('href');

                    if (href === "#chat") {
                        document.getElementById('eltropy-liveHelpButton').click();
                        return;
                    }

                    if (href !== '#' && link.getAttribute('role') !== 'tab') {
                        scrollTo(document.querySelector(href));
                    }
                });
            });

        // Initialize animations
        onScrollInit(document.querySelectorAll('.os-animation'));

        // Handle staggered animations
        document.querySelectorAll('.staggered-animation')
            .forEach(el => {
                onScrollInit(new Array(el), el.closest('.staggered-animation-container'));
            });

        //copy to clipboard functionality
        document.querySelectorAll('[data-copy]')
            .forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    copyToClipboard(el);
                });
            });

        //floating app badges in icon list promos
        document.querySelectorAll('.icons-list-promo__apps')
            .forEach(el => {
                const widget = el.closest('.icons-list-promo');
                let lastScrollTop = document.documentElement.scrollTop;
                const MAX_OFFSET = 15;
                const STEP = 3;

                if (!widget) return;

                window.addEventListener('scroll', () => {
                    const currentScrollTop = document.documentElement.scrollTop;
                    const currentY = getTranslateY(el);
                    let nextY = currentScrollTop > lastScrollTop ? currentY - STEP : currentY + STEP;

                    nextY = Math.max(-MAX_OFFSET, Math.min(MAX_OFFSET, nextY));

                    // Additionally clamp to widget bottom edge
                    el.style.transform = `translate3d(0,${nextY}px,0)`;
                    const elRect = el.getBoundingClientRect();
                    const widgetRect = widget.getBoundingClientRect();
                    if (elRect.bottom > widgetRect.bottom) {
                        nextY -= (elRect.bottom - widgetRect.bottom);
                        nextY = Math.max(-MAX_OFFSET, nextY);
                        el.style.transform = `translate3d(0,${nextY}px,0)`;
                    }

                    if (window.scrollY <= 50) {
                        el.style.transform = `translate3d(0,0,0)`;
                    }

                    lastScrollTop = currentScrollTop;
                }, { passive: true });

                const breakpoints = ['enter-xs', 'enter-sm', 'enter-md', 'enter-lg', 'enter-xl', 'enter-xxl'];
                breakpoints.forEach(eventName => {
                    document.addEventListener(eventName, () => {
                        el.style.transform = '';
                        lastScrollTop = document.documentElement.scrollTop;
                    });
                });
            });

        //floating highlight functionality
        document.querySelectorAll('.floating-highlight')
            .forEach(el => {
                const highlight = el.querySelector('.highlight');
                const image = el.closest('.promo-image');
                let lastScrollTop = 0;
                let scrollBound = false;
                const MAX_OFFSET = 15; // max px from starting position in either direction
                const STEP = 3;        // px moved per scroll event

                if (!highlight || !image) return;

                const onScroll = () => {
                    const currentScrollTop = document.documentElement.scrollTop;
                    const currentY = getTranslateY(highlight);
                    let nextY = currentScrollTop > lastScrollTop ? currentY - STEP : currentY + STEP;

                    // Clamp to range so highlight never drifts too far from its start
                    nextY = Math.max(-MAX_OFFSET, Math.min(MAX_OFFSET, nextY));

                    // Additionally clamp to image bottom edge
                    highlight.style.transform = `translate3d(0,${nextY}px,0)`;
                    const highlightRect = highlight.getBoundingClientRect();
                    const imageRect = image.getBoundingClientRect();
                    if (highlightRect.bottom > imageRect.bottom) {
                        nextY -= (highlightRect.bottom - imageRect.bottom);
                        nextY = Math.max(-MAX_OFFSET, nextY);
                        highlight.style.transform = `translate3d(0,${nextY}px,0)`;
                    }

                    lastScrollTop = currentScrollTop;
                };

                const bindScrollWhenReady = () => {
                    if (scrollBound) return;
                    scrollBound = true;
                    lastScrollTop = document.documentElement.scrollTop;
                    window.addEventListener('scroll', onScroll, { passive: true });
                };

                // animation-complete is added to the .floating-highlight wrapper, not the inner .highlight
                if (el.classList.contains('animation-complete')) {
                    bindScrollWhenReady();
                } else {
                    const observer = new MutationObserver(() => {
                        if (el.classList.contains('animation-complete')) {
                            bindScrollWhenReady();
                            observer.disconnect();
                        }
                    });
                    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
                }

                const breakpoints = ['enter-xs', 'enter-sm', 'enter-md', 'enter-lg', 'enter-xl', 'enter-xxl'];
                breakpoints.forEach(eventName => {
                    document.addEventListener(eventName, () => {
                        highlight.style.transform = '';
                        lastScrollTop = document.documentElement.scrollTop;
                    });
                });
            });



        //section transition margin
        document.querySelectorAll('.section-transition')
            .forEach(el => {
                setTransitionMargin(el);

                // List of breakpoint events
                const breakpoints = ['enter-xs', 'enter-sm', 'enter-md', 'enter-lg', 'enter-xl', 'enter-xxl'];

                breakpoints.forEach(eventName => {
                    document.addEventListener(eventName, () => {
                        setTransitionMargin(el);
                    });
                });
            });
    };

    const setTransitionMargin = (element) => {
        let height = element.offsetHeight;
        element.style.marginTop = `-${height / 2}px`;
        element.style.marginBottom = `${height / 2}px`;
    };

    const getTranslateY = (element) => {
        const style = window.getComputedStyle(element);
        const transform = style.transform || style.webkitTransform || style.mozTransform;

        if (transform === 'none') {
            return 0; // No transform applied
        }

        // Check if it's a 2D or 3D matrix
        if (transform.startsWith('matrix3d')) {
            const matrixValues = transform.split('(')[1].split(')')[0].split(',');
            // The translateY value is the 14th element in a 3D matrix
            return parseFloat(matrixValues[13]);
        } else if (transform.startsWith('matrix')) {
            const matrixValues = transform.split('(')[1].split(')')[0].split(',');
            // The translateY value is the 6th element in a 2D matrix
            return parseFloat(matrixValues[5]);
        }

        return 0; // Fallback if transform format is unexpected
    };

    // Add overlay element
    const addOverlay = () => {
        if (!document.body.querySelector('.overlay')) {
            const overlay = document.createElement('div');
            overlay.className = 'overlay fade';
            document.body.prepend(overlay);
            overlay.classList.add('show');
        }
    };

    // Remove overlay element
    const removeOverlay = () => {
        document.body.querySelector('.overlay')?.remove();
    };

    // Initialize scroll-based animations
    const onScrollInit = (items, trigger) => {
        items.forEach(element => {
            const animationClass = element.dataset.osAnimation;
            const animationDelay = element.dataset.osAnimationDelay;

            // Apply animation delay
            element.style.animationDelay = animationDelay;

            const animationTrigger = trigger || element;

            // Using IntersectionObserver instead of Waypoint
            const observer = new IntersectionObserver(([entry]) => {
                if (entry.isIntersecting) {
                    element.addEventListener('animationend', () => {
                        element.classList.add('animation-complete');
                        element.classList.remove('animate__animated');
                        observer.disconnect();
                    }, { once: true });

                    element.classList.add('animate__animated', animationClass);
                }
            }, {
                threshold: 0.10,
                rootMargin: '0px'
            });

            observer.observe(animationTrigger);
        });
    };

    // Announce text for screen readers
    const speak = (text, priority = 'polite') => {
        const id = `speak-${Date.now()}`;
        const element = document.createElement('div');
        element.id = id;
        element.setAttribute('aria-live', priority);
        element.classList.add('sr-only');
        document.body.appendChild(element);

        setTimeout(() => {
            element.textContent = text;
        }, 100);

        setTimeout(() => {
            element.remove();
        }, 1000);
    };

    const copyToClipboard = (el) => {
        navigator.clipboard.writeText(el.dataset.copy);

        var tooltip = new bootstrap.Tooltip(el);
        tooltip.show();

        setTimeout(() => {
            tooltip.hide();
        }, 1000);
    }

    // Get URL query parameter
    const getUrlParameter = (name) => {
        const params = new URLSearchParams(window.location.search);
        return params.get(name) || '';
    };

    // Smooth scroll to element
    const scrollTo = (element) => {
        element?.scrollIntoView({ behavior: 'smooth' });
    };

    return {
        init,
        addOverlay,
        removeOverlay,
        getUrlParameter
    };
})();


// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', App.init);